// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__kknpp","Input":"Auth_Input__tjrTV"};